import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, useTheme } from "@mui/material";
import { faCircle } from "@fortawesome/free-solid-svg-icons";
import styles from "../css/DeviceConnectionStatusButton.module.css";

interface DeviceConnectionStatusButtonProps {
    isOnline: boolean;
}

export const DeviceConnectionStatusButton = ({isOnline}: DeviceConnectionStatusButtonProps) => {
    const theme = useTheme();

    return (
        <Button
            variant="outlined" 
            data-testid={"connection-status-button"}
            className={styles.deviceStatusButton}
            style={{
                color: isOnline ? theme.palette.success.main : "#d32f2f",
                borderColor: isOnline ? theme.palette.success.main : "#d32f2f",
            }}
        >
            <FontAwesomeIcon icon={faCircle} className={styles.dotIcon} data-testid={"connection-status-icon"}/>
            {isOnline ? "Online": "Offline"}
        </Button>
    );
}